import React from "react";

const Loading = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-[#050816]">
            <div className="w-12 h-12 border-4 border-t-blue-500 border-white rounded-full animate-spin"></div>
            <h1 className="mt-4 text-xl text-white">Loading...</h1>
        </div>
    );
};

export default Loading;
